export default __webpack_public_path__ + "static/media/rocket_anim_26.da1f5c96.png";